// extracted by mini-css-extract-plugin
export default {"bonusBox":"bonus-box-module__bonusBox__CmBKz","detailsBox":"bonus-box-module__detailsBox__1maGP"};